import { render, staticRenderFns } from "./system_function_sysset.vue?vue&type=template&id=e456edbe"
import script from "./system_function_sysset.vue?vue&type=script&lang=js"
export * from "./system_function_sysset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports